import actionTypes from '../actionTypes';

export const getRoles = () => ({
  type: actionTypes.ROLES_GET_REQUEST,
});

export const getOwnershipTypes = () => ({
  type: actionTypes.OWNERSHIP_TYPES_GET_REQUEST,
});

export const getContractBlocks = () => ({
  type: actionTypes.CONTRACT_BLOCKS_GET_REQUEST,
});

export const updateContractBlockContent = (id, content, options) => ({
  type: actionTypes.CONTRACT_BLOCKS_UPDATE_CONTENT,
  payload: { id, content, options },
});

export const resetContractBlockContents = () => ({
  type: actionTypes.CONTRACT_BLOCKS_RESET_CONTENTS,
});

export const getWorkTypes = () => ({
  type: actionTypes.WORK_TYPES_GET_REQUEST,
});

export const getSubWorkTypes = () => ({
  type: actionTypes.SUBWORK_TYPES_GET_REQUEST,
});



// WEBPACK FOOTER //
// src/redux/actions/global.js